import NoConnexion from '../components/NoConnexion'
import DefaultLayout from '../layout/DefaultLayout'

const OfflinePage = () => {
  return (
    <DefaultLayout>
      <NoConnexion text="Cette page n’est pas disponible hors connexion" />
    </DefaultLayout>
  )
}

export default OfflinePage
